import { render } from "./select-bases.vue?vue&type=template&id=4d67327c&scoped=true"
import script from "./select-bases.vue?vue&type=script&lang=js"
export * from "./select-bases.vue?vue&type=script&lang=js"

import "./select-bases.vue?vue&type=style&index=0&id=4d67327c&lang=scss&scoped=true"

import exportComponent from "/Users/kgeek/KGEEK/PERSONNAL/REMA/traning_lists/csn/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d67327c"]])

export default __exports__